export default "__VITE_ASSET__4e34f201__"